import { createAction } from "@reduxjs/toolkit";
import { AnimationJsonData } from "src/types/gift";

export default {
  setGiftAnimation: createAction<{
    jsonData: AnimationJsonData;
    url: string;
  }>("lwc/user/setGiftAnimation"),
};
